export const notificationSagaActionTypes = {
    callGetNotificationListSaga: "callGetNotificationListSaga",
    callAddNotificationSaga: "callAddNotificationSaga",
    callUpdateNotificationSaga: "callUpdateNotificationSaga",
    callDeleteNotificationSaga: "callDeleteNotificationSaga",
}

export type notificationPayloadType = {
    ID: number;
    type: string;
    type_id: string;
    partner_id: string;
    type_date: string;
    message: string;
}

export const getNotificationListSagaAction : () => {
    type: string,
} = () => {
    return {
        type: notificationSagaActionTypes.callGetNotificationListSaga,
    }
}

export const addNotificationSagaAction : (payload: notificationPayloadType) => {
    type: string,
    payload: notificationPayloadType
} = (payload: notificationPayloadType) => {
    return {
        type: notificationSagaActionTypes.callAddNotificationSaga,
        payload: payload
    }
}

export const updateNotificationSagaAction: (payload: notificationPayloadType) => {
    type: string,
    payload: notificationPayloadType
} = (payload: notificationPayloadType) => {
    return {
        type: notificationSagaActionTypes.callUpdateNotificationSaga,
        payload: payload
    }
}

export const deleteNotificationSagaAction : (ID: number) => {
    type: string,
    payload: {
        ID: number
    }
} = (ID: number) => {
    return {
        type: notificationSagaActionTypes.callDeleteNotificationSaga,
        payload: {
            ID: ID
        }
    }
}
